import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-order_btn_checkbox_normal-1",
  "use": "icon-order_btn_checkbox_normal-1-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-order_btn_checkbox_normal-1\"><path d=\"m10 20c-5.5 0-10-4.5-10-10s4.5-10 10-10 10 4.5 10 10-4.5 10-10 10zm0-19c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z\" fill=\"#969799\" /><path d=\"m10 20c5.5 0 10-4.5 10-10s-4.5-10-10-10-10 4.5-10 10 4.5 10 10 10z\" fill=\"#4bd214\" /><path d=\"m7.4 14.4-3.5-3.5c-.2-.2-.4-.6-.4-.9s.1-.6.4-.9c.2-.2.6-.4.9-.4s.6.1.9.4l2.7 2.7 5.3-5.3c.2-.3.5-.5.8-.5s.6.1.9.4c.2.2.4.6.4.9s-.1.6-.4.9l-6.2 6.2c-.2.2-.6.4-.9.4s-.6-.2-.9-.4z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/order_btn_checkbox_normal-1.svg
// module id = MEsH
// module chunks = 87